import Vue from 'vue';
import { LOAD_STORED_AUTH, RESET_AUTH, SET_AUTH_TOKEN } from '../types';

const auth = {
    state: {
        token: null,
    },
    mutations: {
        [LOAD_STORED_AUTH](state) {
            state.token = localStorage.getItem('token');
        },
        [SET_AUTH_TOKEN](state, { token, cookie = null }) {
            state.token = token;
            localStorage.setItem('token', token);
            Vue.api.headers.Authorization = `Bearer ${token}`;

            if (!cookie) return;

            let cookieDomain = window.location.hostname;
            cookieDomain = cookieDomain
                .split('.')
                .slice(-2)
                .join('.');
            document.cookie = `tecnotion_user=${cookie}; Domain=.${cookieDomain}; Path=/; Max-Age=2147483647`;
        },
        [RESET_AUTH](state) {
            state.token = null;
            localStorage.removeItem('token');
            Vue.api.headers.Authorization = '';
            // Expire user data cookie
            document.cookie = 'tecnotion_user=; Max-Age=0';
        },
    },
    actions: {
        async verifyEmail({ commit }, { token, email }) {
            try {
                const response = await Vue.api
                    .post('/verify-email')
                    .send(JSON.stringify({ token, email }));
                commit(SET_AUTH_TOKEN, response);
                return true;
            } catch {
                return false;
            }
        },
    },
    getters: {
        isLoggedIn(state) {
            return !!state.token;
        },
    },
};

export default auth;
